import { useCallback, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import DateFiltersProvider from "components/shared/filters/DateFilters/context";
import DateFilters from "components/shared/filters/DateFilters";
import Header from "./Header";
import Toolbar, { SETTINGS_SECTIONS, type SettingsSection } from "./Toolbar";
import Content from "./Content";

const DEFAULT_SECTION: SettingsSection = "availability";

function Settings() {
    const [searchParams, setSearchParams] = useSearchParams();

    const section = useMemo<SettingsSection>(() => {
        const value = searchParams.get("section");
        return SETTINGS_SECTIONS.includes(value as SettingsSection) ? (value as SettingsSection) : DEFAULT_SECTION;
    }, [searchParams]);

    const setSection = useCallback((value: SettingsSection) => {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set("section", value);
            return next;
        }, { replace: true });
    }, [setSearchParams]);

    useEffect(() => {
        if (searchParams.has("section")) return;
        setSection(section);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DateFiltersProvider modes={["week", "custom"]} mode="week">
            <div className="tw-h-full tw-w-full tw-bg-white tw-rounded-lg tw-overflow-hidden tw-flex tw-flex-col">
                <Header />
                <Toolbar value={section} onChange={setSection}>
                    <DateFilters />
                </Toolbar>
                <div className="tw-flex-1 tw-overflow-auto">
                    <Content />
                </div>
            </div>
        </DateFiltersProvider>
    );
}

export default Settings;
